function setRootFontSize() {
  let baseWidth = 768;
  let clientWidth = document.documentElement.clientWidth;
  if (clientWidth > 1920) {
    document.documentElement.style.fontSize = 100 + "px";
    return;
  } else if (clientWidth < 1920 && clientWidth > 768) {
    baseWidth = 1920;
  } else if (clientWidth < 768) {
    baseWidth = 768;
  }
  let fontSize = 100 / (baseWidth / clientWidth); // 根据像素密度调整font-size
  document.documentElement.style.fontSize =
    Math.max(50, Math.min(100, fontSize)) + "px";
}

window.addEventListener("resize", setRootFontSize);
setRootFontSize();
